import { Option } from '../../../../core/components/Fields/SelectField.tsx';

export const slimRenderOption = (option: Option) => (
    <span className="text-content-strong min-w-100 flex">{option.label}</span>
);
